/**
 * AB#2108 (Admin V1 pilot gate, AB#2110) — the published Devanza legal documents
 * (marketing site, canonical domain; Terms & Conditions and Privacy Policy v1.0,
 * EN + AR). Owners must be able to open them before they are asked to consent.
 * The Arabic version is served with `?lang=ar`.
 */
const LEGAL_BASE_URL = 'https://devanza.devura.ae/legal';

export type LegalDocument = 'terms' | 'privacy';

export function legalDocumentUrl(document: LegalDocument, language: string): string {
    const url = `${LEGAL_BASE_URL}/${document}`;
    return language === 'ar' ? `${url}?lang=ar` : url;
}
